import { render, staticRenderFns } from "./gj-radio-group.vue?vue&type=template&id=e23be00e&scoped=true&"
import script from "./gj-radio-group.vue?vue&type=script&lang=js&"
export * from "./gj-radio-group.vue?vue&type=script&lang=js&"
import style0 from "./gj-radio-group.vue?vue&type=style&index=0&id=e23be00e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23be00e",
  null
  
)

export default component.exports